import dateFormat from "../../../functions/dateFormat";

export default ({data, onClick, onDoubleClick, Parent}) => {

    const l1 = [];
    Object.keys(data).map((key, value) => {
        const l2 = [];
        const l3 = [];
        const age = Math.floor((new Date() - new Date(data[key].dob)) / (1000 * 60 * 60 * 24 * 365));
        const {firstName, lastName, id} = data[key];
        l2.push(value + 1, `${firstName} /       ${lastName}`, dateFormat(data[key].dob), age || '');
        let keys = Object.keys(data[key]['passport']); // add a passport data
        if (keys && keys.length) {
            const {number, expiry, land} = data[key]['passport'][keys[0]];
            l2.push(number, dateFormat(expiry), land);
        } else {
            l2.push('', '', '')
        }
        let contactKeys = Object.keys(data[key]['contact']); // add a contact data
        let y = '';
        if (contactKeys && contactKeys.length) {
            for (let contact of contactKeys) {
                let c = data[key]['contact'][contact]['type'];
                if (c == 'פלאפון' || c == 'טלפון') {y = data[key]['contact'][contact]['data']}
            }
        }
        l2.push(y, id);
        l2.map((value2, key2) => {
            l3.push(<td key={key2}> {value2} </td>);
        })
        onClick || l1.push(<tr key={value} onDoubleClick={() => {onDoubleClick(key)}} >{l3}</tr>);
        onClick && l1.push(<tr key={value} onDoubleClick={() => {onDoubleClick(key)}} onClick={(e) => {onClick(value + 1, e, key)}} >{l3}</tr>);
    })

    return (
        <>
        <table className="Table">
            <thead>
                <tr>
                {["", "שם", "תאריך לידה", "גיל", "דרכון", "תאריך תפוגה", "אזרחות", "פלאפון", "ת.ז"].map((value, key) => 
                    <td key={key}> {value} </td>
                )}
                </tr>
            </thead>
            
            <tbody ref={Parent}>
                {l1}
            </tbody>
        </table>
        
        </>
    )
}